(function (app, ng) {
    app.directive("airDatePicker",
        [
            function () {
                return {
                    restrict: "A",
                    require: "ngModel",
                    scope: {
                        options: "&",
                        datepicker: "=",
                        model: "=ngModel"
                    },
                    link: function (scope, element, attrs, ctrl) {
                        var defaults = {
                            language: {
                                days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                                daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                                daysMin: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                                months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                                monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                                today: "Today",
                                clear: "Clear",
                                dateFormat: "mm/dd/yyyy",
                                timeFormat: "hh:ii aa",
                                firstDay: 0
                            }
                        };
                        ctrl.$formatters.push(function (value) {
                            if (value) $(element).data("datepicker").selectDate(new Date(value));
                            return value;
                        });
                        defaults.onSelect = function (formattedDate, date, inst) {
                            ctrl.$setViewValue(formattedDate);
                        };
                        defaults.onShow = function (inst, animationComplete) {
                            if (!animationComplete) {
                                var doesFit = false;
                                ng.forEach(["right center", "right bottom", "top right", "top center", "bottom center"],
                                    function (position) {
                                        if (!doesFit) {
                                            inst.update("position", position);
                                            var fits = isElementInViewport(inst.$datepicker[0]);
                                            if (fits.all) {
                                                doesFit = true;
                                            }
                                        }
                                    });
                            }
                        }
                        function isElementInViewport(el) {
                            var rect = el.getBoundingClientRect();
                            var fitsLeft = (rect.left >= 0 && rect.left <= $(window).width());
                            var fitsTop = (rect.top >= 0 && rect.top <= $(window).height());
                            var fitsRight = (rect.right >= 0 && rect.right <= $(window).width());
                            var fitsBottom = (rect.bottom >= 0 && rect.bottom <= $(window).height());
                            return {
                                top: fitsTop,
                                left: fitsLeft,
                                right: fitsRight,
                                bottom: fitsBottom,
                                all: (fitsLeft && fitsTop && fitsRight && fitsBottom)
                            };
                        }
                        var dateRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
                        attrs.$observe("ngModel",
                            function (value) {
                                scope.$watch(value,
                                    function (newVal) {
                                        if (!newVal) return false;
                                        if (!dateRegex.test(newVal)) return false;
                                        $(element).data("datepicker").selectDate(new Date(newVal));
                                        $(element).data("datepicker").date = date;
                                    });
                            });
                        scope.$watch("model",
                            function (newVal) {
                                if (!newVal) return false;
                                if (!dateRegex.test(newVal)) return false;
                                var date = new Date(newVal);
                                $(element).data("datepicker").selectDate(date);
                                $(element).data("datepicker").date = date;
                            });
                        scope.$watch(function () {
                            return scope.options();
                        },
                            function (newVal) {
                                if (!newVal) return false;
                                if (newVal.minDate) newVal.minDate = new Date(newVal.minDate);
                                if (newVal.maxDate) newVal.maxDate = new Date(newVal.maxDate);
                                $(element).data("datepicker").update(ng.extend(defaults, newVal));
                            },
                            true);
                        $(element).datepicker(ng.extend(defaults, scope.options()));
                        if (scope.datepicker)
                            scope.datepicker = $(element).data("datepicker");
                    }
                };
            }
        ]);
})(window.app, window.angular); //jshint ignore:line